import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { RequestStatus } from '@app/constants';
import { IRequestFailed } from '@app/types';
import { IDepartment, IDepartmentState } from './types';

const initialState: IDepartmentState = {
  departments: {},
  deleteDepartment: {},
  addDepartment: {},
};

const slice = createSlice({
  name: 'departments',
  initialState,
  reducers: {
    getDepartments(state) {
      state.departments.status = RequestStatus.RUNNING;
    },
    getDepartmentsSuccess(state, action: PayloadAction<IDepartmentState['departments']['data']>) {
      state.departments.status = RequestStatus.SUCCESS;
      state.departments.data = action.payload;
    },
    getDepartmentsFailed(state, action: PayloadAction<IRequestFailed>) {
      state.departments.status = RequestStatus.ERROR;
      state.departments.error = action.payload;
    },
    //
    deleteDepartment(state, action: PayloadAction<{ id: number }>) {
      state.deleteDepartment.status = RequestStatus.RUNNING;
    },
    deleteDepartmentSuccess(state, action: PayloadAction<IDepartment>) {
      state.deleteDepartment.status = RequestStatus.SUCCESS;
    },
    deleteDepartmentFailed(state, action: PayloadAction<IRequestFailed>) {
      state.deleteDepartment.status = RequestStatus.ERROR;
      state.deleteDepartment.error = action.payload;
    },
    //
    addDepartment(state, action: PayloadAction<IDepartment>) {
      state.addDepartment.status = RequestStatus.RUNNING;
    },
    addDepartmentSuccess(state, action: PayloadAction<IDepartment>) {
      state.addDepartment.status = RequestStatus.SUCCESS;
      state.addDepartment.data = action.payload;
    },
    addDepartmentFailed(state, action: PayloadAction<IRequestFailed>) {
      state.addDepartment.status = RequestStatus.ERROR;
      state.addDepartment.error = action.payload;
    },
  },
});
export default slice.reducer;

export const {
  getDepartments,
  getDepartmentsSuccess,
  getDepartmentsFailed,
  deleteDepartment,
  deleteDepartmentFailed,
  deleteDepartmentSuccess,
  addDepartment,
  addDepartmentSuccess,
  addDepartmentFailed,
} = slice.actions;
